import { collectDescendantStableIds } from '@/lib/blocks/tree';
import type { PageBlock } from '@/types/block';
import { canTargetParentAcceptActiveBlock, isConstrainedParentExitAttempt } from '../policies';
import type { DropResolutionContext } from './context-builder';

export const hasValidTargetHierarchy = ({
  context,
  childrenByParent,
  structuralRegionRootByBlockId,
  protectedBlockIds,
}: {
  context: DropResolutionContext;
  childrenByParent: Map<string, PageBlock[]>;
  structuralRegionRootByBlockId?: ReadonlyMap<string, string>;
  protectedBlockIds?: ReadonlySet<string>;
}): boolean => {
  const { activeBlock, activeId, activeParent, activeParentId, targetParentId, targetParent } =
    context;

  if (structuralRegionRootByBlockId) {
    const activeRegionRoot = structuralRegionRootByBlockId.get(activeId);
    const targetRegionRoot = targetParentId
      ? structuralRegionRootByBlockId.get(targetParentId)
      : undefined;
    if (
      !activeRegionRoot ||
      activeRegionRoot !== targetRegionRoot ||
      protectedBlockIds?.has(activeId)
    ) {
      return false;
    }
  }

  if (
    targetParentId === activeId ||
    isConstrainedParentExitAttempt({ activeParent, activeParentId, targetParentId })
  ) {
    return false;
  }

  if (!targetParentId) {
    return true;
  }

  if (
    !canTargetParentAcceptActiveBlock({ activeBlock, targetParent }) ||
    collectDescendantStableIds(activeId, childrenByParent).has(targetParentId)
  ) {
    return false;
  }

  return true;
};
